<div class="px-px-135 pt-px-24">
  <div class="card-container">
    <div class="card-header d-flex justify-content-between">
      <div>Détails de votre établissement</div>
    <svg-icon src="assets/icons/edit.svg" (click)="openDetailDialog()" class="cursor-pointer"></svg-icon>
    </div>
    <div class="card-body">

      <div class="row">
        <div class="col-6">
          <div class="fw-3 fs-13">Nom de l’établissement</div>
          <div class="fs-16 fw-4">{{ establishment.name || 'N/A' }}</div>

          <div class="fw-3 fs-13 mt-px-16">Type d’établissement</div>
          <div class="fs-16 fw-4">{{establishment.typeetablissement || 'N/A'}}</div>

          <div class="fw-3 fs-13 mt-px-16">Email principal</div>
          <div class="fs-16 fw-4">{{ establishment.mailpersonnecontact || 'N/A' }}</div>
        </div>

        <div class="col-6">
          <div class="fw-3 fs-13">Nombre de salariés</div>
          <div class="fs-16 fw-4">{{ establishment.nombresalaries || 'N/A' }}</div>

          <div class="fw-3 fs-13 mt-px-16">Patients pris en charge par an</div>
          <div class="fs-16 fw-4">{{ establishment.nombreannuelpatients || 'N/A' }}</div>
        </div>
      </div>

      <div class="my-px-24">
        <div class="fw-3">Description</div>
        <div >
         {{establishment.description || 'N/A'}}
        </div>
      </div>
        <app-text-separator text="Données administratives"></app-text-separator>

      <div class="fw-3 fs-13 mt-px-24">SIRET</div>
      <div class="fs-16 fw-4">{{ establishment.numsiret || 'N/A' }}</div>

      <div class="fw-3 fs-13 mt-px-16">Numéro FINESS</div>
      <div class="fs-16 fw-4">{{ establishment.numfiness || 'N/A' }}</div>

      <!-- P6 (client clinique) : Mode de gestion masqué — code conservé
      <div class="fw-3 fs-13 mt-px-16">Choix de la gestion administrative de l’intérim</div>
      <div class="fs-16 fw-4">{{ establishment.platformManagedBy ?
        establishment.platformManagedBy === 'COLLARY' ? 'Par Collary' : 'Par votre établissement'  :'N/A' }}</div>
      -->

    </div>
  </div>
</div>
